import { useState, useEffect, useMemo, forwardRef } from 'react';
import {
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Checkbox,
  ListItemText,
  ListSubheader,
  TextField,
  InputAdornment,
  Typography,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { getAllTasks } from 'src/services/timeManagementService';

interface TaskNameMultiSelectProps {
  value: string[] | [],
  onChange: (e: any) => void,
  projectId: string,
  titile?: string,
  disabled?: boolean;
  taskView?:boolean
}

const TaskNameMultiSelect = forwardRef((props: TaskNameMultiSelectProps, _ref) => {
  const [list, setList] = useState([]);
  const [selectedItems, setSelectedItems] = useState<string[]>([]);
  const [searchText, setSearchText] = useState<string>('');
  
  const containsText = (text, searchText) =>
    text?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1;

  const fetchLists = () => {
    const payload = {
      projectId: props?.projectId,
      endDate: null,
      startDate: null,
      taskId: null,
      taskName: null,
      type: null,
      status: null,
    }
    getAllTasks(payload).then((res) => {
      const data = res?.data?.data
      setList(data?.taskSummery);
    });
  }

  const filteredLists = useMemo(
    () =>
      list.length > 0 &&
    list?.filter((option) => containsText(option?.taskName, searchText)),
    [list, searchText]
  );

  useEffect(() => {
    const selectedName = [];
    if(props?.value && props?.value.length > 0){
      for(let i=0; i < props?.value.length; i++){
        const result = list.filter(e => e.taskId === props?.value[i]);
        selectedName.push(result[0]?.taskName);
      }
    }
    setSelectedItems(selectedName);
  }, [list, props?.value]);


  return (
    <FormControl fullWidth disabled={props?.disabled ? props?.disabled : false}>
      <InputLabel
        style={{
          fontSize: '12px'
        }}
      >
        {props?.titile ? props?.titile : 'Task Name'}
      </InputLabel>
      <Select
        id="filter-resource"
        sx={{ mt: 1 }}
        style={{
          fontSize: '12px',
          height: '2rem'
        }}
        multiple
        size="small"
        value={props.value}
        renderValue={() => selectedItems.join(', ')}
        onChange={(e) => props?.onChange(e)}
        onClose={() => setSearchText('')}
        onOpen={() => fetchLists()}
      >
        <ListSubheader>
          <TextField
            id="search-task-id"
            size="small"
            autoFocus
            placeholder="Type to search..."
            fullWidth
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              )
            }}
            onChange={(e) => setSearchText(e.target.value)}
            onClick={(e) => {
              e.stopPropagation();
            }}
            onKeyDown={(e) => {
              if (e.key !== 'Escape') {
                e.stopPropagation();
              }
            }}
          ></TextField>
        </ListSubheader>
        {
          filteredLists?.length > 0 &&
          filteredLists.map((fl, i) => {
            return (
              <MenuItem key={fl?.taskId} 
                value={fl?.taskId}>
                  <Checkbox checked={props?.value.indexOf(fl?.taskId as never) > -1} />
                  <ListItemText primary={fl?.taskName} />
              </MenuItem>
            );
          })
        }
        {
        props?.taskView && list && list.length == 0 && (<Typography
            style={{
              fontSize: '14px',
              margin: '1rem',
              textAlign: 'center',
              color:"grey"
            }}
            variant="body2"
          >
            {"< - "}There are no activities created in this project{" - >"}
          </Typography>
          )}
      </Select>   
    </FormControl>
  );
});

export default TaskNameMultiSelect;
